<template>
  <!-- :style="{marginRight:isMobile.isMobile?'13px':'0px',marginLeft:isMobile.isMobile?'13px':'13px',margin:isMobile.isMobile?'10px 0':'0px'}" -->
  <div
    :style="{
      marginRight: isMobile.isMobile ? '13px' : '0px',
      marginLeft: isMobile.isMobile ? '13px' : '13px',
    }"
  >
    <div
      :style="{
        marginRight: isMobile.isMobile ? '13px' : '0px',
        marginLeft: isMobile.isMobile ? '13px' : '13px',
        margin: isMobile.isMobile ? '10px 0' : '0px',
      }"
    >
      <md-toolbar
        class="headers"
        v-if="isMobile.isMobile"
        color="#4caf50"
        dark
        :style="{
          minHeight: isMobile.isMobile ? '44px' : '56px',
          height: isMobile.isMobile ? '44px !important' : '56px',
        }"
      >
        <v-menu transition="slide-y-transition" offset-y nudge-bottom="5" :close-on-click="true">
          <template v-slot:activator="{ on, attrs }">
            <span :style="{fontSize:'15px',width:'156px '}">{{ course.name ? course.name : '课程' }}</span>
          </template>
          <v-list class="py-1" dense>
            <v-list-item-group active-class="v-List-actived" mandatory color="indigo">
              <v-list-item
                class="list-item-hover-active py-0 text-center"
                v-for="item in courseList1"
                :key="item._id"
                @click="checkCourse(item)"
              >
                <v-list-item-content class="pa-0">
                  <v-list-item-title
                    v-text="item.name"
                    align="left"
                    class="text-body-2 ls-0 text-typo font-weight-600 mb-0"
                  ></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-menu>

        <v-btn
          v-if="this.courseData.hasAuthModify"
          v-hasPermi="['dev::project::add']"
          class="btnAdd"
          icon
          small
          @click="handleProjectChange('add')"
          style="margin-left: 5px; color: #fff"
        >
          <span
            class="material-icons"
            style="
              transform: rotate(45deg);
              font-size: 18px;
              margin-top: -3px;
              margin-left: 3px;
              color: #fff;
            "
            >close</span
          >
          <md-tooltip md-direction="top">添加{{ returnProject(this.courseData) }}</md-tooltip>
        </v-btn>

        <v-btn class="btnAdd" icon small @click="handleSceneChange('add')">
          <span class="material-icons" style="font-size: 18px; color: #fff">view_in_ar</span>
          <md-tooltip md-direction="top">任务场景</md-tooltip>
        </v-btn>

        <v-btn
          v-if="this.courseData.hasAuthModify"
          v-hasPermi="['dev::project::publish']"
          icon
          small
          @click.stop="handlePublish"
        >
          <span class="material-icons" style="font-size: 18px; color: #fff">publish</span>
          <md-tooltip md-direction="top">发布</md-tooltip>
        </v-btn>
        <v-btn
          v-if="this.courseData.hasAuthModify"
          v-hasPermi="['dev::project::publish']"
          icon
          small
          @click.stop="handleUpgrade"
        >
          <span class="material-icons" style="font-size: 18px; color: #fff">sync_alt</span>
          <md-tooltip md-direction="top">版本更新</md-tooltip>
        </v-btn>
        <v-btn icon small style @click="goback">
          <span class="material-icons" style="font-size: 18px; color: #fff">reply_all</span>
          <md-tooltip md-direction="top">返回</md-tooltip>
        </v-btn>
        <md-button
          v-if="isMobile.isMobile"
          class="md-toolbar-toggle md-just-icon md-round md-simple "
          :class="{ toggled: $sidebar.showSidebar }"
          style="float: right; color: #fff !important; margin-right: -10px;margin-left: auto"
          @click.stop="toggleSidebar"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </md-button>
      </md-toolbar>
    </div>

    <div>
      <v-card @keyup.ctrl.alt="showPPTList = true" :style="{overflow: 'hidden',padding:isMobile.isMobile?'10px 0px':'0px'}">
        <v-app-bar
          color="#4caf50"
          dark
          :style="{ height: isMobile.isMobile ? '44px' : '56px' }"
          v-if="!isMobile.isMobile"
        >
          <v-menu transition="slide-y-transition" offset-y nudge-bottom="5" :close-on-click="true">
            <template v-slot:activator="{ on, attrs }">
              <span style="font-size: 15px">{{ course.name ? course.name : '课程' }}</span>
            </template>
            <v-list class="py-1" dense>
              <v-list-item-group active-class="v-List-actived" mandatory color="indigo">
                <v-list-item
                  class="list-item-hover-active py-0 text-center"
                  v-for="item in courseList1"
                  :key="item._id"
                  @click="checkCourse(item)"
                >
                  <v-list-item-content class="pa-0">
                    <v-list-item-title
                      v-text="item.name"
                      align="left"
                      class="text-body-2 ls-0 text-typo font-weight-600 mb-0"
                    ></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>

          <v-btn
            v-if="this.courseData.hasAuthModify"
            v-hasPermi="['dev::project::add']"
            class="btnAdd"
            icon
            small
            @click="handleProjectChange('add')"
            style="margin-left: 5px"
          >
            <span
              class="material-icons"
              style="transform: rotate(45deg); font-size: 18px; margin-top: -3px; margin-left: 3px"
              >close</span
            >
            <md-tooltip md-direction="top">添加{{ returnProject(this.courseData) }}</md-tooltip>
          </v-btn>

          <v-btn class="btnAdd" icon small @click="handleSceneChange('add')">
            <span class="material-icons" style="font-size: 18px">view_in_ar</span>
            <md-tooltip md-direction="top">任务场景</md-tooltip>
          </v-btn>

          <v-btn
            v-if="this.courseData.hasAuthModify"
            v-hasPermi="['dev::project::publish']"
            icon
            small
            @click.stop="handleUpgrade"
          >
            <span class="material-icons" style="font-size: 18px">sync_alt</span>
            <md-tooltip md-direction="top">版本更新</md-tooltip>
          </v-btn>

          <v-btn
            v-if="this.courseData.hasAuthModify"
            v-hasPermi="['dev::project::publish']"
            icon
            small
            @click.stop="handlePublish"
          >
            <span class="material-icons" style="font-size: 18px">publish</span>
            <md-tooltip md-direction="top">发布</md-tooltip>
          </v-btn>

          <v-btn v-if="this.courseData.hasAuthModify" v-hasPermi="['dev::project::publish']" icon small @click="handleModelResource">
            <span class="material-icons" style="font-size: 18px">3d_rotation</span>
            <md-tooltip md-direction="top">交付模型关联管理</md-tooltip>
          </v-btn>

          <!-- <v-btn icon small @click="handleExamConfig">
            <span class="material-icons" style="font-size: 18px">settings</span>
            <md-tooltip md-direction="top">考核配置</md-tooltip>
          </v-btn> -->

          
          <v-btn icon small style @click="goback">
            <span class="material-icons" style="font-size: 18px">reply_all</span>
            <md-tooltip md-direction="top">返回</md-tooltip>
          </v-btn>

        </v-app-bar>

        <v-row class="md-layout md-gutter projectMenuQrap">
          <SplitPane
            direction="row"
            :min="20"
            :max="80"
            :triggerLength="20"
            :paneLengthPercent.sync="paneLengthPercent"
          >
            <template v-slot:one>
              <div>


                 <dragmenu :projectData='projectData' v-show="isMobile.isMobile"></dragmenu>
                <Menu class="lstProject" v-show="!isMobile.isMobile" @setBtndisabled="setBtndisabled"  />
              </div>
            </template>

            <template v-slot:two>
              <div>
                <Main class="md-layout-item" ref="Main" v-show="!isMobile.isMobile" />
              </div>
            </template>
          </SplitPane>

          <!-- <div v-if="showMenu" transition="scale-transition" class="projectMenu">
                  <Menu class="lstProject" @setBtndisabled="setBtndisabled" />
              
                </div>

                <v-col
                  v-if="!showEditor"
                  :cols="!showMenu ? 12 : 9.8"
                  transition="scale-transition"
                  class="md-layout-item md-xsmall-size-100"
                >
                  <Main class="md-layout-item md-xsmall-size-100" ref="Main" />
                </v-col>

                <v-col v-else :cols="!showMenu ? 12 : 9">
                  <Editor /> -->
          <!-- </v-col> -->
        </v-row>

        <v-navigation-drawer
          v-model="drawer"
          absolute
          bottom
          temporary
          right
          mini-variant-width="80"
          :width="500"
        >
          <v-list nav dense>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>任务场景</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item-group v-model="group" active-class="deep-purple--text text--accent-4">
              <v-list-item v-for="(item, index) in sceneList" :key="item.id">
                <template v-slot:default="{ active }">
                  <v-list-item-action>
                    <v-checkbox :input-value="active" color="deep-purple" size="mini"></v-checkbox>
                  </v-list-item-action>
                  <v-list-item-content class="text-body-2"
                    >{{ index + 1 }}.{{ item.name }}</v-list-item-content
                  >
                  <v-list-item-action>
                    <template slot:default>
                      <v-btn icon small @click="handleToEditor(item)">
                        <v-icon small>mdi-pencil</v-icon>
                      </v-btn>
                    </template>
                  </v-list-item-action>
                </template>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-navigation-drawer>
        <PublishForm />
        <UpgradeForm :showPublishVersion="showUpgradeForm" @close="showUpgradeForm = false"/>
        <SortDialog />
        <TaskTemplateInfo />

        <v-dialog
          v-model="showPPTList"
          scrollable
          persistent
          :overlay="false"
          max-width="500px"
          transition="dialog-transition"
        >
          <v-overlay :value="overlay">
            <v-card class="d-flex flex-column justify-center white px-10">
              <div class="d-flex justify-center py-5">
                <v-progress-circular indeterminate color="success"></v-progress-circular>
              </div>
              <div class="d-flex justify-center pb-5 green--text text-bold">ppt文件上传中...</div>
            </v-card>
          </v-overlay>
          <v-card>
            <v-card-title>
              <span class="headline">PPT列表</span>
            </v-card-title>
            <v-card-text>
              <v-list>
                <v-list-item v-for="(item, index) in pptList" :key="item.fileId">
                  <v-list-item-title style="display: flex">
                    <span>{{ index + 1 }}.{{ item.fileName }}</span>
                    <v-spacer></v-spacer>
                    <v-chip
                      :color="item.handleProcess === 'complate' ? 'green' : 'gray'"
                      class="mr-4"
                      >{{ item.handleProcess === 'complate' ? '处理完毕' : '处理中' }}</v-chip
                    >
                  </v-list-item-title>
                  <v-list-item-action>
                    <v-btn icon small @click="handleRemovePPT(index)">
                      <v-icon small>mdi-delete</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
              <div
                v-if="pptList === undefined || pptList.length === 0"
                class="py-3 text-gray text-center"
              >
                暂未上传PPT文件
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="showPPTList = false" small>取消</v-btn>
              <div style="position: relative">
                <input class="choose-img__input" type="file" accept=".pptx" @change="filechange" />
                <v-btn class="mx-3" color="success" small>上传PPT</v-btn>
              </div>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card>
    </div>
    <ExamConfigDialog
      :dialogExamConfig.sync="dialogExamConfig"
      :treeData="treeData"
    />
    <ModelCheckDialog
      :dialogModel.sync="dialogModel"
      :queryCourseModelFunction="queryCourseModelData"
      :queryModelFunction="queryModelData"
      :relationId="currentCourseId"
      @submit="handleModelCheckSubmit"
    />
  </div>
</template>
<script>
import Main from './Main/index.vue';
import Menu from './Menu/index.vue';
import Editor from './editor.vue';
import PublishForm from './Version/PublishForm.vue';
import UpgradeForm from './Version/UpgradeForm.vue';
import SortDialog from './SortDialog.vue';
import { mapGetters, mapState } from 'vuex';
import CourseGraph from './CourseGraph.vue';
import Swal from 'sweetalert2';
import TaskTemplateInfo from './Main/Action/TaskTemplateInfo.vue';
import { getCourseById, delCourse } from '@/api/course';
import { ossUpload } from '@/api/common';
import { handlePPTFile } from '@/api/course';
import SplitPane from './splitPane.vue';
import dragmenu from './dragMenu.vue'
import ExamConfigDialog from '@/components/Cards/ExamConfigDialog';
import {
  queryModelByCourseId,
  queryLimitPropertyModelList,
} from '@/api/model_resource';
import ModelCheckDialog from '@/components/Cards/ModelCheckDialog';

export default {
  components: {
    CourseGraph,
    Menu,
    Main,
    Editor,
    PublishForm,
    UpgradeForm,
    SortDialog,
    TaskTemplateInfo,
    SplitPane,
    dragmenu,
    ExamConfigDialog,
    ModelCheckDialog,
  },
  watch: {
    isPictureTableStatus(news) {
      let obj = {
        path: '/design',
        switchFlag: news,
      };
      window.localStorage.setItem('switchFlag', JSON.stringify(obj));
      if (news) {
        this.isTable = true;
        this.isPicture = false;
      } else {
        this.isPicture = true;
        this.isTable = false;
      }
    },
    '$route.query.detailId': {
      immediate: true,
      handler() {
        //根据页面传递过来的id来进行章节项目的回显
        let detailId = this.$route.query.detailId;
        getCourseById(detailId).then(res => {
          this.courseData = res.data;
          this.projectData = res.data.children
          // this.projectData.forEach(item=>{
          //   item.active = false;
          // })

          if (this.courseData.sectionType) {
            this.courseData.children &&
              this.courseData.children.forEach(item => {
                item.sectionType = this.courseData.sectionType;
              });
          }
          this.pptList = res.data.pptFileList ?? [];
          this.courseData.children &&
            this.courseData.children.sort((a, b) => {
              return a.orderNum - b.orderNum;
            });
          this.$store.dispatch('courseAndProject/updateCourse', Object.assign({}, res.data));
          this.$store.dispatch('editor/refreshSceneList', Object.assign({}, res.data));
        });
      },
    },
  },  
  created() {
    window.addEventListener('keydown', event => {
      // 检查是否按下了 ctrl+s
      if (event.ctrlKey && event.altKey && event.key === '1') {
        // 阻止默认行为（保存网页）
        event.preventDefault();
        this.showPPTList = true;
      }
    });
  },
  destroyed() {
    window.removeEventListener('keydown');
  },

  mounted() {
    console.log(this.taskList,'111111')
    let _this = this;
    this.$EventBus.$on('setSwitchFlag', function (data) {
      if (data) {
        let data1 = JSON.parse(data);
        if (data1.path == '/design') {
          _this.isPictureTableStatus = data1.switchFlag;
          window.localStorage.setItem('switchFlag', data);
        }
      }
    });

    if (window.location.pathname == '/designDetail') {
      let timer = setTimeout(() => {
        let designIdMenu = document.getElementById('designIdMenu');
        if (designIdMenu) {
          let designIdMenu = document.getElementById('designIdMenu');
          designIdMenu.style.cssText =
            'background-color:#4caf50;box-shadow: 0 12px 20px -10px rgba(76, 175, 80, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(76, 175, 80, 0.2);';
          clearTimeout(timer);
        }
      }, 400);
    }
  },
  destroyed() {
    this.$EventBus.$off('setSwitchFlag');
  },
  computed: {
    ...mapGetters(['showMenu', 'showEditor', 'courseList', 'isMobile','taskTotal','project','course','currentProjectIndex','showMenu','taskList']),
    taskFilterList() {
      return this.taskList;
    },
    preName() {
      return this.course.childType === 'chapter' ? '章节' : '任务';
    },
    from() {
      return (this.pagination.currentPage - 1) * this.pagination.perPage;
    },
    to() {
      return this.pagination.currentPage * this.pagination.perPage;
    },
    total() {
      const total = this.taskFilterList ? this.taskFilterList.length : 0;
      return total;
    },
    taskFilterList() {
      return this.taskList;
    },
    ...mapState({
      // courseList: (state) => state.courseAndProject.courseList,
      course: state => state.courseAndProject.course,
      project: state => state.courseAndProject.project,
      sceneList: state => state.editor.sceneList,
    }),
    drawer: {
      get() {
        return this.$store.getters.showSceneListDrawer;
      },
      set(val) {
        this.handleDrawer(val);
      },
    },
    // isShown() {
    //   // 你可以在这里定义你的逻辑，例如：
    //   // 如果路由参数中包含id，并且id的值是你期望的值，则显示元素
    //   const tab = this.$route.query.tab;
    //   if(tab=='0'){
    //      return false
    //   }
    //   return true; // 替换 'expectedValue' 为你期望的id值
    // }
  },
  data() {
    return {
      dialogExamConfig: false,
      treeData: [],
      projectData:[],
      paneLengthPercent: 28,
      overlay: false,
      courseData: {},
      courseList1: [],
      isPictureTableStatus: false,
      isTable: false,
      isPicture: true,
      isEditDelDisabledStatus: true,
      course_id: '',
      course_info: {},
      project_id: '',
      projectMap: {},
      group: '',
      showPPTList: false,
      pptList: [],
      showUpgradeForm: false,
      dialogModel: false,
      currentCourseId: '',
    };
  },
  methods: {
    queryCourseModelData(params) {
      return queryModelByCourseId(params);
    },
    queryModelData(params) {
      return queryLimitPropertyModelList(params);
    },
    handleModelResource() {
      this.dialogModel = true;
      this.currentCourseId = this.courseData._id;
      console.log(this.currentCourseId);
    },
    handleExamConfig() {
      this.dialogExamConfig = true;
      console.log(this.projectData);
      this.treeData = this.projectData;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    returnProject(data) {
      let str = '';

      if (data && data.sectionType && data.sectionType == 'xm') {
        str = '项目';
      } else if (data && data.sectionType && data.sectionType == 'zj') {
        str = '章节';
      } else if (data && data.sectionType && data.sectionType == 'qj') {
        str = '情境';
      } else {
        str = '章节';
      }
      return str;
    },
    handleUpgrade() {
      this.showUpgradeForm = true
    },
    async filechange(e) {
      // 传入一个参数对象即可得到基于该参数对象的文本内容
      const file = e.target.files[0];
      this.overlay = true;
      let res;
      try {
        res = await ossUpload({ path: `coursePPTFile/`, file });
      } catch (error) {
        console.error('ppt 文件上传报错', error);
        this.overlay = false;
        return;
      }
      this.overlay = false;
      const arr = res.name.split('/');
      let obj = {
        fileId: arr[arr.length - 2],
        fileName: file.name,
        fileUrl: res.url,
        // 处理状态 默认处理中 处理成功表示为 'complated'
        handleProcess: 'pending',
      };
      this.pptList.push(obj);
      this.$store.dispatch(
        'courseAndProject/saveCourse',
        Object.assign({ pptFileList: this.pptList }, this.course)
      );
      handlePPTFile({
        courseId: this.course._id,
        fileId: obj.fileId,
        fileUrl: obj.fileUrl,
      });
    },
    async handleRemovePPT(index) {
      let result = await Swal.fire({
        title: '删除信息',
        text: `${this.pptList[index].fileName} 被删除后将无法恢复，请确认！`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'md-button md-success btn-fill',
        cancelButtonClass: 'md-button md-danger btn-fill',
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        buttonsStyling: false,
      });
      if (result.value) {
        this.pptList.splice(index, 1);
        this.$store.dispatch(
          'courseAndProject/saveCourse',
          Object.assign({ pptFileList: this.pptList }, this.course)
        );
      }
    },
    async handleDelete() {
      let result = await Swal.fire({
        title: '删除信息',
        text: `${this.courseData.name} 记录被删除后将无法恢复，请确认！`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'md-button md-success btn-fill',
        cancelButtonClass: 'md-button md-danger btn-fill',
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        buttonsStyling: false,
      });
      if (result.value) {
        const delResult = await delCourse(this.courseData);
        console.log(delResult);
        if (delResult.code == 200) {
          // this.pagination.page = 1;
          // this.queryData();
          this.goback();
          Swal.fire({
            title: '已删除!',
            text: `您已经删除 ${this.courseData.name}`,
            type: 'success',
            confirmButtonClass: 'md-button md-success btn-fill',
            buttonsStyling: false,
          });
        }
      }
    },
    handleEdit() {
      this.$router.push({ name: 'NewCourse', params: this.courseData });
    },
    goback() {
      this.$router.push('/design');
    },
    setBtndisabled(type) {
      this.isEditDelDisabledStatus = type;
    },
    // async handleProjectRemove() {
    //   let result = await Swal.fire({
    //     title: "提示",
    //     text: `确认删除项目${this.project.name}?`,
    //     type: "error",
    //     showCancelButton: true,
    //     confirmButtonClass: "md-button md-success btn-fill",
    //     cancelButtonClass: "md-button md-danger btn-fill",
    //     confirmButtonText: "确 定",
    //     cancelButtonText: "取 消",
    //     buttonsStyling: false,
    //   });

    //   if (result.value) {
    //     this.$store.dispatch("courseAndProject/removeProject");
    //   }
    // },
    async handlePublish() {
      this.$store.dispatch('courseAndProject/reverseShowPublishVersion', true);
    },
    async handleSort() {
      this.$store.commit('task/SET_TASK_SORT_DIALOG', true);
    },
    async handleToEditor(editInfo) {
      this.$router.push({
        path: '/editor-' + editInfo._id,
      });
    },
    async handleDrawer(status) {
      this.$store.dispatch('editor/reverseDrawerStatus', status);
    },
    async handleCourseChange(status) {
      this.$store.dispatch('courseAndProject/reverseShowCourseEdit', status);
    },
    async handleProjectChange(status) {
      this.$store.dispatch('courseAndProject/reverseShowProjectEdit', status);
      this.$store.dispatch('courseAndProject/projectType', this.courseData);
    },
    async handleSceneChange(status) {
      this.$store.dispatch('courseAndProject/reverseShowSceneEdit', status);
    },
    async checkCourse(course) {
      this.course_info = course;
      if (course && course.children.length <= 0) {
        this.$store.state.editor.sceneList = [];
      }
      this.$store.dispatch('courseAndProject/updateCourse', Object.assign({}, course));
      this.project_id = '';
      //切换课程时候默认拿到第一条项目去查场景
      this.$EventBus.$emit('selectCourse');
    },
    async checkProject(id) {
      this.project_id = id;
      const project = this.course.children.find(item => item._id === this.project_id);
      this.$store.dispatch('courseAndProject/updateProject', Object.assign({}, project));
      this.$store.dispatch('editor/closeEditor');
    },
  },
};
</script>
<style>
.choose-img__input {
  width: 80px;
  height: 31px;
  position: absolute;
  left: 10px;
  opacity: 0;
  z-index: 999;
}
</style>

<style scoped>
.projectMenu {
  width: 25%;
  resize: horizontal;
  overflow: auto;
  /* border-right: 1px solid red; */
  overflow: hidden;
  resize: both;
  resize: horizontal;
  cursor: pointer;
}

.projectMenuQrap {
  margin: 0 auto;
  padding: 10px;
  width: 100%;
  height: auto;
  overflow: hidden;
}

.lstProject {
  overflow: hidden;
}

/* .page {
 height: 500px;
 padding: 10px;
 width: 100%;
 background: #000;
} */

.headers {
  background: #4caf50 !important;
  height: 64px;
  overflow: hidden;
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
}


</style>
